import { useHandler } from "@redotech/react-util/hook";
import { useState } from "react";

export interface UseMessageInputResult {
  messageContent: string;
  setMessageContent: (value: string) => void;
  clearMessageContent: () => void;
  isMessageSendLoading: boolean;
}

/**
 * Hook for managing message input state.
 */
export function useMessageInput(): UseMessageInputResult {
  const [messageContent, setMessageContent] = useState("");
  const [isMessageSendLoading] = useState(false); // For future send functionality

  const clearMessageContent = useHandler(() => {
    setMessageContent("");
  });

  return {
    messageContent,
    setMessageContent,
    clearMessageContent,
    isMessageSendLoading,
  };
}
